import routerOptions0 from "/Users/axin/Documents/qbworkfile/nuxt-front-web/node_modules/.pnpm/nuxt@3.9.3_@unocss+reset@0.60.3_floating-vue@5.2.2_less@4.2.0_nprogress@0.2.0_rollup@4.14.3_t_kdwhqfpeb43qzfakc3nqkm7p4q/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}